import React from 'react';

const SlaOperationalRiskPanel = ({ data }) => {
  const info = data || {};
  const techRows = Array.isArray(info.technician_load_risk) ? info.technician_load_risk : [];

  return (
    <section className="rounded-2xl border border-slate-800 bg-slate-900/60 p-4">
      <h3 className="text-sm font-semibold text-slate-100">SLA & Operational Risk</h3>
      <div className="mt-3 grid gap-3 md:grid-cols-3 xl:grid-cols-6">
        <Metric label="Open Tickets" value={Number(info.total_open_tickets || 0)} tone="text-slate-100" />
        <Metric label="SLA On Track" value={Number(info.sla_on_track || 0)} tone="text-emerald-200" />
        <Metric label="SLA At Risk" value={Number(info.sla_at_risk || 0)} tone="text-amber-200" />
        <Metric label="SLA Breached" value={Number(info.sla_breached || 0)} tone="text-red-300" />
        <Metric label="MTTR (menit)" value={Number(info.mttr_minutes || 0).toFixed(1)} tone="text-cyan-200" />
        <Metric label="Urgent Dispatch" value={Number(info.urgent_dispatch_queue || 0)} tone="text-purple-200" />
      </div>

      <div className="mt-4 overflow-x-auto rounded-lg border border-slate-800">
        <table className="min-w-full text-xs">
          <thead className="bg-slate-950/70 text-slate-400">
            <tr>
              <th className="px-3 py-2 text-left">Technician</th>
              <th className="px-3 py-2 text-right">Active Load</th>
              <th className="px-3 py-2 text-right">At Risk</th>
              <th className="px-3 py-2 text-right">Breached</th>
            </tr>
          </thead>
          <tbody>
            {techRows.slice(0, 8).map((row) => (
              <tr key={row.technician_id} className="border-t border-slate-800/80 text-slate-200">
                <td className="px-3 py-2">{row.technician_name}</td>
                <td className="px-3 py-2 text-right">{Number(row.active_load || 0)}</td>
                <td className="px-3 py-2 text-right text-amber-200">{Number(row.at_risk || 0)}</td>
                <td className="px-3 py-2 text-right text-red-300">{Number(row.breached || 0)}</td>
              </tr>
            ))}
            {techRows.length === 0 ? (
              <tr>
                <td colSpan={4} className="px-3 py-3 text-center text-slate-500">Belum ada data risiko teknisi.</td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </section>
  );
};

const Metric = ({ label, value, tone }) => (
  <div className="rounded-lg border border-slate-800 bg-slate-950/70 p-3">
    <div className="text-xs text-slate-400">{label}</div>
    <div className={`mt-1 text-lg font-semibold ${tone}`}>{value}</div>
  </div>
);

export default SlaOperationalRiskPanel;
